import { z } from 'zod';

const requiredStringSchema = z.string().min(1);

const idNameSchema = z.object({
  Id: requiredStringSchema,
  Name: requiredStringSchema
});

export const participantSchema = z.object({
  Participant: idNameSchema,
  DutyRankId: requiredStringSchema,
  Comments: z.string()
});

export const participantArraySchema = z.array(participantSchema);

export const participantArrayApiResponseSchema = z.object({
  Data: participantArraySchema
});

export type Participant = z.infer<typeof participantSchema>;
export type ParticipantArray = z.infer<typeof participantArraySchema>;
export type ParticipantArrayApiResponse = z.infer<typeof participantArrayApiResponseSchema>;
